import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { IpService } from '../../shared/servicio/ip/ip.service';
import { environment } from 'src/environments/environment';
declare var $: any;
@Component({
  selector: 'app-menu-horizontal',
  templateUrl: './menu-horizontal.component.html',
  styleUrls: ['./menu-horizontal.component.css'],
})
export class MenuHorizontalComponent implements OnInit {
  constructor(
    public _ip: IpService,
    private _http: HttpClient,
    public router: Router
  ) {}

  isLeftMenuActive;

  ngOnInit() {
    this.isLeftMenuActive = true;
    this.menu();
  }

  // funcion javascript para el toogle del movil
  menu() {
    $(document).ready(function () {
      $('#sidebarCollapse').on('click', function () {
        console.log(this.isLeftMenuActive);
        this.isLeftMenuActive = !this.isLeftMenuActive;
        $('#sidebar').toggleClass('active');
      });
    });
  }

  logout() {
    this._http.get(environment.Api_logout).subscribe(
      (data) => {
        localStorage.removeItem('token');
        localStorage.removeItem('type');
        this.router.navigate(['/']);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
